import React from "react"
import Drawer, {DrawerProps} from "../../../Drawer"

export const StandardSearch = ({open, onClose, text, children}: DrawerProps) => {
    return (
        <Drawer anchor="right" open={open} onClose={onClose} text={text.drawer} showCloseIcon>
            {children}
        </Drawer>
    )
}

export default StandardSearch
